import packageJson from "../../package.json";

declare var process: {
    env: {
        API_URL: string,
        AGENT_API_URL?: string,
        SAME_URL_AS_BACKEND: boolean
    }
}

export const environment = {
    API_URL: process.env["API_URL"],
    AGENT_API_URL: process.env["AGENT_API_URL"] || 'http://127.0.0.1:8100',
    version: "Development Build: " + packageJson.version
};
